import React from 'react';
import styled from 'styled-components';
import Footer from './Footer';

// Shared chrome for the entry screen: the centered card layout, the ConvoCoach
// logo and tagline, and the footer.
const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: #f8f9fa;
`;

const Logo = styled.h1`
  color: #0d9488;
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  text-align: center;
`;

const Tagline = styled.p`
  color: #666;
  margin-bottom: 2rem;
  text-align: center;
  font-size: 1.2rem;
`;

const Layout = ({ children }) => (
  <Container>
    <Logo>ConvoCoach</Logo>
    <Tagline>Rehearse the conversations that matter, with realistic AI<br />role-play and honest feedback from your coach.</Tagline>
    {children}
    <Footer />
  </Container>
);

export default Layout;
